import DOMPurify from 'dompurify';
export const sanitize = (data) => {
    try {
        return DOMPurify.sanitize(data);
    }
    catch (error) {
        return data;
    }
};
